import { styled } from '../../../../components/src/components/Layout/ThemeProvider/ThemeProvider';

export const Anchor = styled.a`
  text-outline: none;
  color: ${({ theme }) => theme.colors.primary1};
`
